var siteSearch = {
	
    toggleSiteSearch: function() {
        var self = this;
        var $siteSearchToggle = $('.js-search-toggle');
        var $siteSearch = $('.js-search-form');
        var $siteSearchCloseIcon = $('.js-search-close');
        var $siteSearchOpen = $('.js-search-open');

        // Focus the search form and change focus to the input when the search is opened
        $siteSearchToggle.on('click', function() {
            $siteSearch.toggleClass('is-open');
            if ($siteSearch.hasClass('is-open')) {
                $siteSearch.find('input#s').trigger('focus');
                $siteSearchOpen.hide();
                $siteSearchCloseIcon.show();
            } else {
                $siteSearchToggle.trigger('focus');
                $siteSearchOpen.show();
                $siteSearchCloseIcon.hide();
            }
        });
    },

	init: function() {
		var self = this;

        self.toggleSiteSearch();
	}

};

module.exports = siteSearch;